// Copyright 1999-2022. Plesk International GmbH. All rights reserved.
import Vue from "vue";
import VueRouter from "vue-router";
// eslint-disable-next-line no-unused-vars
import moment from "moment";
import Layout from "@/components/Layout/Layout";

// Pages
import Dashboard from "@/pages/Dashboard/Dashboard";
import Typography from "@/pages/Typography/Typography";
import Tables from "@/pages/Tables/Basic";
import Notifications from "@/pages/Notifications/Notifications";
import Icons from "@/pages/Icons/Icons";
import Charts from "@/pages/Charts/Charts";
import Maps from "@/pages/Maps/Google";
import Error from "@/pages/Error/Error";
import Login from "@/pages/Login/Login";
import Clientes from "../pages/Clientes/Clientes";
import Usuarios from "../pages/Usuarios/Usuarios";
import EstadoUsuarios from "../pages/Usuarios/EstadoUsuarios";
import Estadistica from "../pages/Estadistica/Estadistica";
import Casos from "../pages/Caso/Casos";
import CasosArchivados from "../pages/Caso/CasosArchivados";
import GestionarCaso from "../pages/Caso/GestionarCaso";
import Chat from "../pages/Caso/Mensaje";
import ChatPerito from "../pages/Caso/MensajePerito";
import ChatDibujante from "../pages/Caso/MensajeDibujante";
import Gestiones from "../pages/Gestiones/Gestiones";
import Gestionar from "../pages/Caso/Gestionar";
import Area from "../pages/Area/Area";
import Informacion from "../pages/Caso/DatosCaso";
import Vehiculos from "../pages/Vehiculos/Vehiculos";
import LoginCliente from "@/pages/Login/LoginCliente";
import Empresas from "@/pages/Empresas/Empresas";
import Exportaciones from "@/pages/Exportaciones/Exportaciones";
import Auth from "../pages/Login/Auth";
import { guardGestionCasos } from "./auth-guard";
// import { guardGestionCasos } from "./auth-guard";
import { auth, db } from "@/firebase";
import store from "@/store/";

Vue.use(VueRouter);
// rutas
const routes = [
  {
    path: "/login",
    name: "Auth",
    component: Auth,
    // beforeEnter: autenticadoGuard,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
      },
      {
        path: "auth-cliente/:id?",
        name: "LoginCliente",
        component: LoginCliente,
      },
    ],
  },
  {
    path: "/gestionar-caso/:id?",
    name: "GestionarCaso",
    component: GestionarCaso,
    beforeEnter: guardGestionCasos,
    children: [
      {
        path: "",
        name: "informacion",
        component: Informacion,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(
        //     /* webpackChunkName: "informacion" */ "../pages/Caso/DatosCaso"
        //   ),
      },
      {
        path: "chat",
        name: "chat",
        component: Chat,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "chat" */ "../pages/Caso/Mensaje"),
      },
      {
        path: "gestionar",
        name: "gestionar",
        component: Gestionar,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "gestionar" */ "../pages/Caso/Gestionar"),
      },
      {
        path: "mapa",
        name: "maps",
        component: Maps,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "maps" */ "../pages/Maps/Google"),
      },
      {
        path: "chat_perito",
        name: "chat_perito",
        component: ChatPerito,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "maps" */ "../pages/Maps/Google"),
      },
      {
        path: "chat_dibujante",
        name: "chat_dibujante",
        component: ChatDibujante,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "maps" */ "../pages/Maps/Google"),
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    name: "Layout",
    component: Layout,
    // beforeEnter: autenticadoGuard,
    children: [
      {
        path: "usuarios",
        name: "Usuarios",
        component: Usuarios,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estado-usuarios",
        name: "EstadoUsuarios",
        component: EstadoUsuarios,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estadistica/:id?",
        name: "Estadistica",
        component: Estadistica,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "clientes",
        name: "Clientes",
        component: Clientes,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "casos",
        name: "Casos",
        component: Casos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "casos-archivados",
        name: "CasosArchivados",
        component: CasosArchivados,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "vehiculos",
        name: "Vehiculos",
        component: Vehiculos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "empresas",
        name: "Empresas",
        component: Empresas,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "exportaciones",
        name: "Exportaciones",
        component: Exportaciones,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "areas",
        name: "Area",
        component: Area,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "gestiones",
        name: "gestiones",
        component: Gestiones,
        meta: {
          requiresAuthCliente: true,
        },
        // component: () =>
        //   import(/* webpackChunkName: "maps" */ "../pages/Maps/Google"),
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "typography",
        name: "Typography",
        component: Typography,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tables",
        name: "Tables",
        component: Tables,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "icons",
        name: "Icons",
        component: Icons,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "*",
    name: "Error",
    component: Error,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (
    (to.meta.requiresAuth || to.meta.requiresAuthCliente) &&
    !localStorage.getItem("cliente")
  ) {
    if (
      to.name !== "Login" &&
      !auth.currentUser &&
      !store.getters.user &&
      !store.getters.logged
    ) {
      next({
        path: "/login",
        replace: true,
      });
    } else {
      // const to = auth.currentUser.auth.currentUser.accessToken;
      const to = localStorage.getItem("token_login");
      // console.log("---------------Token to-----------------");
      // console.log({ to });
      // console.log("---------------End Token to-----------------");
      // console.log("-----------------auth usuario----------------------------");
      // console.log(auth.currentUser);
      // console.log(
      //   "------------------end auth usuario---------------------------"
      // );

      db.collection("usuarios")
        .where("uiid", "==", `${auth.currentUser.uid}`)
        .get()
        .then((res) => {
          const {
            login,
            duracion_sesion,
            token_login: tokenLogin,
          } = res.docs[0].data();
          if (login === false || tokenLogin !== to) {
            store.commit("salir");
            return;
          }
          let duracion = duracion_sesion ? duracion_sesion : 15;
          // eslint-disable-next-line no-undef
          let tiempo_login = moment(
            parseInt(auth.currentUser?.metadata.lastLoginAt)
          )
            .add(duracion, "minutes")
            .format();
          let tiempo_actual = moment().format();
          if (tiempo_login < tiempo_actual) {
            // actualizamos la propiedad login del usuario a false
            store.dispatch("ActualizarLoginUsuario", {
              id: store.state.logueado.id,
              login: false,
              token_login: to,
              salir: true,
              ip: "",
            });
            return;
          }
          next();
        });
    }
  } else {
    next();
  }

  // SOLO SI ES CLIENTE
  if (
    localStorage.getItem("cliente") &&
    localStorage.getItem("id") &&
    (to.name === "informacion" || to.name === "chat" || to.name === "maps")
  ) {
    // console.log("desde cliente");
    // console.log(to.meta);
    let id = localStorage.getItem("id");
    const caso = await db.collection("casos").doc(id).get();
    const { fecha_ingreso } = caso.data();
    if (fecha_ingreso) {
      let tiempo_login_cliente = moment(fecha_ingreso)
        .add(120, "minutes")
        .format();
      // console.log(tiempo_login_cliente, moment().format());
      if (tiempo_login_cliente < moment().format()) {
        // console.log("sacar al cliente  salirCliente", id);
        store.dispatch("ActualizarLoginCliente", {
          id,
          login: false,
          token_login: "",
        });
        store.commit("salirCliente");
      }
    }
  }
});

export default router;
